import styled from "styled-components"
import { device } from "utils/breakpoints.js"

export const TextInputContainer = styled.div`
  display: flex;
  margin-bottom: ${props => (props.type === "hidden" ? "0" : "30px")};
  position: relative;
  flex-direction: column;

  @media ${device.desktop} {
    margin-bottom: ${props => (props.type === "hidden" ? "0" : "44px")};
    width: auto;
  }

  svg {
    position: absolute;
    top: ${props => (props.area ? "18px" : "50%")};
    left: 17px;
    width: 24px;
    transform: ${props => (props.area ? null : "translateY(-50%);")};

    @media ${device.desktop} {
      top: ${props => (props.area ? "26px" : "50%")};
      left: 20px;
    }
    path {
      transition: 100ms;
      fill: ${props =>
        props.fieldActive ? props.theme.primaryColor : "#d3d2ce"};
    }
  }

  textarea,
  input[type="text"] {
    /* Remove First */
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    /* Then Style */
    border-radius: 0;
    border: 1px solid black;
  }
`

export const Input = styled.input`
  display: block;
  outline: none;
  width: 100%;
  height: 54px;
  padding: 15px;
  border: 1px solid black;
  background: none;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.4);
  -webkit-appearance: none;
  :hover {
    border: 1px solid #c9ac8d;
  }

  :focus {
    border: 1px solid #c9ac8d;
    color: black;
  }

  border: ${props => props.error && "1px solid #fa3e3e"} !important;

  @media ${device.desktop} {
    height: 46px;
    padding: 15px;
    font-size: 20px;
    width: ${props => (props.short ? "232px" : "402PX;")};
  }
`

export const Area = styled.textarea`
  display: block;
  outline: none;
  width: 100%;
  padding: 15px;
  height: 251px;
  border: 1px solid black;
  background: none;
  resize: none;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.4);
  -webkit-appearance: none;

  :hover {
    border: 1px solid #c9ac8d;
  }

  :focus {
    border: 1px solid #c9ac8d;
    color: black;
  }

  .error {
    border: 1px solid #fa3e3e;
  }

  border: ${props => props.error && "1px solid #fa3e3e"} !important;

  @media ${device.desktop} {
    height: 200px;
    font-size: 20px;
    max-width: 655px;
  }
`
